import React, { useCallback } from 'react';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import { CONTEXT_KEYS, useArtboardContext } from '../../context/complexArtboardContext';

const UpgradePlanDesign = () => {
  const upgradeModalInfoSelector = useCallback(store => store[CONTEXT_KEYS.UPGRADE_MODAL_INFO], []);
  const [upgradeModalInfo, updateArtboard] = useArtboardContext(
    upgradeModalInfoSelector,
    `ComplexArtboard`,
  );

  return (
    <UpgradePlanModal
      visible={upgradeModalInfo.visible}
      modalText={upgradeModalInfo.message}
      onCancel={() => updateArtboard({ [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: { visible: false } })}
    />
  );
};

export default UpgradePlanDesign;
